/* ------------------------------------------------------------------
   Krishna Furniture — city showroom page behaviour.

   Lifted verbatim out of the Admin page body, where it was two inline <script> blocks that
   the page editor kept stripping. It drives the Locate Us state/city/category filters, the
   showroom photo slider and the enquiry form's hidden-iframe submit.

   Every hook it relies on (kfStateSelect, kfCitySelect, kfCategorySelect, kfStoreSlider,
   kfEmptyState, the .kf-locate-store-card data attributes and the form) is reproduced by the
   kf-city-* sections, so the markup it expects is unchanged.
   ------------------------------------------------------------------ */

(function () {
    var stateSelect = document.getElementById('kfStateSelect');
    var citySelect = document.getElementById('kfCitySelect');
    var categorySelect = document.getElementById('kfCategorySelect');
    var clearBtn = document.getElementById('kfClearAll');
    var list = document.getElementById('kfStoreList');
    var countLabel = document.getElementById('kfStoreCount');
    var emptyState = document.getElementById('kfEmptyState');

    if (!list) return;

    var cards = Array.prototype.slice.call(list.querySelectorAll('.kf-locate-store-card'));

    function applyFilters() {
      var state = stateSelect.value;
      var city = citySelect.value;
      var category = categorySelect.value;
      var visibleCount = 0;

      cards.forEach(function (card) {
        var matches =
          (!state || card.dataset.state === state) &&
          (!city || card.dataset.city === city) &&
          (!category || card.dataset.category === category);

        card.style.display = matches ? '' : 'none';
        if (matches) visibleCount++;
      });

      countLabel.textContent = visibleCount + (visibleCount === 1 ? ' Store In India' : ' Stores In India');
      emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    stateSelect.addEventListener('change', applyFilters);
    citySelect.addEventListener('change', applyFilters);
    categorySelect.addEventListener('change', applyFilters);

    clearBtn.addEventListener('click', function () {
      stateSelect.value = '';
      citySelect.value = '';
      categorySelect.value = '';
      applyFilters();
    });

    applyFilters();
  })();

  (function () {
    // Two ids because the Atul Kataria Chowk page has its own design and calls the
    // slider #kfSlider; the dots and arrows are optional there, so every use of them
    // below is guarded.
    var slider = document.getElementById('kfStoreSlider') || document.getElementById('kfSlider');
    if (!slider) return;

    var track = slider.querySelector('.kf-slider-track');
    if (!track) return;
    var slides = track.children;
    if (slides.length < 2) return;
    var dotsWrap = document.getElementById('kfSliderDots') || document.getElementById('kfDots');
    var prevBtn = slider.querySelector('.kf-slider-arrow.prev') || slider.querySelector('.prev');
    var nextBtn = slider.querySelector('.kf-slider-arrow.next') || slider.querySelector('.next');
    var current = 0;
    var timer = null;
    var AUTO_DELAY = 3500;

    for (var i = 0; i < slides.length; i++) {
      (function (n) {
        var dot = document.createElement('span');
        if (n === 0) dot.className = 'active';
        dot.addEventListener('click', function () {
          goTo(n);
          restart();
        });
        if (dotsWrap) dotsWrap.appendChild(dot);
      })(i);
    }

    function goTo(n) {
      current = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (!dotsWrap) return;
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].className = i === current ? 'active' : '';
      }
    }

    function start() {
      timer = setInterval(function () { goTo(current + 1); }, AUTO_DELAY);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function restart() {
      stop();
      start();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); restart(); });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    var touchStartX = 0;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      stop();
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 40) {
        goTo(diff < 0 ? current + 1 : current - 1);
      }
      start();
    }, { passive: true });

    start();
  })();

  (function () {
    var targets = document.querySelectorAll(
      '.kf-store-section, .kf-store-gallery figure, .kf-store-category, .kf-locate-filters, .kf-locate-promo'
    );

    if (!targets.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      return;
    }

    Array.prototype.forEach.call(targets, function (el) {
      el.classList.add('kf-reveal');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kf-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    Array.prototype.forEach.call(targets, function (el) {
      observer.observe(el);
    });

    // Safety net: guarantee every section becomes visible even if the browser
    // never fires an intersection event (automated screenshot tools, some
    // search-engine renderers that don't simulate real scrolling).
    setTimeout(function () {
      Array.prototype.forEach.call(targets, function (el) {
        el.classList.add('kf-in');
      });
      observer.disconnect();
    }, 2000);
  })();

(function () {
    var forms = document.querySelectorAll('form[action*="/contact"]');
    Array.prototype.forEach.call(forms, function (form, formIndex) {
      var nameInput = form.querySelector('input[name="contact[name]"]');
      var phoneInput = form.querySelector('input[name="contact[phone]"]');

      if (nameInput) {
        nameInput.addEventListener('input', function () {
          this.value = this.value.replace(/[^A-Za-z\s]/g, '');
        });
        nameInput.setAttribute('pattern', '[A-Za-z\\s]{2,50}');
        nameInput.setAttribute('title', 'Please enter a valid name (letters only)');
      }

      if (phoneInput) {
        phoneInput.addEventListener('input', function () {
          this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10);
        });
        phoneInput.setAttribute('pattern', '[6-9][0-9]{9}');
        phoneInput.setAttribute('maxlength', '10');
        phoneInput.setAttribute('inputmode', 'numeric');
        phoneInput.setAttribute('title', 'Please enter a valid 10-digit mobile number');
      }

      var submitBtn = form.querySelector('button[type="submit"]');

      // Submit through a hidden iframe instead of fetch(): this is a real, uninterrupted
      // native form submission (form target = an invisible iframe), so Shopify's own
      // anti-spam/bot-protection script — which hooks the real submit event — still runs
      // normally. The earlier fetch()-based AJAX skipped that entirely and got a 400 back.
      var frameName = 'kfContactFrame' + formIndex + Math.random().toString(36).slice(2);
      var iframe = document.createElement('iframe');
      iframe.name = frameName;
      iframe.style.cssText = 'position:absolute;width:1px;height:1px;border:0;opacity:0;pointer-events:none;left:-9999px;';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('tabindex', '-1');
      document.body.appendChild(iframe);
      form.setAttribute('target', frameName);

      var submitted = false;
      var timeoutId = null;

      iframe.addEventListener('load', function () {
        if (!submitted) return; // ignore the iframe's own initial blank load
        clearTimeout(timeoutId);
        form.innerHTML = '<div style="text-align:center;padding:20px 6px;">' +
          '<div style="font-size:34px;line-height:1;margin-bottom:10px;">&#10003;</div>' +
          '<h3 style="margin:0 0 8px;">Thank you!</h3>' +
          '<p style="margin:0;">Your enquiry has been sent. Our team will call you back shortly.</p>' +
          '</div>';
      });

      form.addEventListener('submit', function () {
        if (!form.reportValidity()) return;
        // no preventDefault — let the browser genuinely submit the form, just into the
        // hidden iframe instead of navigating the visible page
        submitted = true;
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }
        timeoutId = setTimeout(function () {
          form.innerHTML = '<div style="text-align:center;padding:20px 6px;">' +
            '<div style="font-size:34px;line-height:1;margin-bottom:10px;">&#9888;&#65039;</div>' +
            '<h3 style="margin:0 0 8px;">Could not confirm that was sent</h3>' +
            '<p style="margin:0 0 14px;">Please call us directly and we will take it from there.</p>' +
            '<a href="tel:+919319574949" style="display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:0 22px;border-radius:999px;background:#5a3a2d;color:#fff;font-weight:700;text-decoration:none;">Call 093195 74949</a>' +
            '</div>';
        }, 45000);
      });
    });
  })();